import React, { useEffect, useRef, useState } from "react";
import { Button } from "reactstrap";
import toast, { Toaster } from "react-hot-toast";
import CostCenterService from "../../../../services/OrderingServices/CostCenterService";

export const PrintBill = ({
  currentOrder,
  totalDiscount,
  calculateTotals,
  orderId,
  user,
  selectedCustomer,
  responseData,
  isestimateprint,
  selectedPayments,
}) => {
  console.log("🚀 ~ PrintBill ~ selectedPayments:", selectedPayments);
  console.log("🚀 ~ PrintBill ~ responseData:", responseData);
  console.log("🚀 ~ PrintBill ~ selectedCustomer:", selectedCustomer);
  const socketRef = useRef(null);
  const [connectionStatus, setConnectionStatus] = useState("disconnected");
  const [userInfo, setUserInfo] = useState(null);
  console.log("🚀 ~ PrintBill ~ userInfo:", userInfo);
  const [webSocketUrl, setWebSocketUrl] = useState(null);
  const [isPrinting, setIsPrinting] = useState(false);
  const [costCenterData, setCostCenterData] = useState(null);
  const isDesktop = () => window.innerWidth >= 992;

  const fetchCostCenter = async () => {
    try {
      const response = await CostCenterService.getList();
      const actualData = Array.isArray(response)
        ? response
        : response?.data || [];

      const billPrinter = actualData.find(
        (item) => item.name?.trim().toLowerCase() === "bill printer"
      );
      setCostCenterData(billPrinter || null);
    } catch (error) {
      console.error("❌ Fetch cost center error:", error);
    }
  };

  useEffect(() => {
    fetchCostCenter();
  }, []);

  useEffect(() => {
    if (!costCenterData?.printerPort) return;

    const storedUserInfo = localStorage.getItem("user");
    if (storedUserInfo) {
      const parsedUserInfo = JSON.parse(storedUserInfo);
      setUserInfo(parsedUserInfo);
      const dynamicWebSocketUrl = `ws://localhost:${costCenterData.printerPort}`;
      setWebSocketUrl(dynamicWebSocketUrl);
    }
  }, [costCenterData]);

  useEffect(() => {
    if (!webSocketUrl) return;

    const connectWebSocket = () => {
      setConnectionStatus("connecting");
      socketRef.current = new WebSocket(webSocketUrl);

      socketRef.current.onopen = () => {
        console.log("WebSocket connection established");
        setConnectionStatus("connected");
      };

      socketRef.current.onclose = () => {
        console.log("WebSocket connection closed");
        setConnectionStatus("disconnected");
      };

      socketRef.current.onerror = (error) => {
        console.error("WebSocket error:", error);
        setConnectionStatus("error");
        if (isDesktop()) {
          toast.error("Connection error. Please refresh or try again later.", {
            duration: 4000,
            position: "top-right",
            style: {
              background: "#fee2e2",
              color: "#b91c1c",
            },
          });
        }
      };

      socketRef.current.onmessage = (event) => {
        try {
          const response = JSON.parse(event.data);
          if (response.status === "success") {
            toast.success(response.message || "Bill printed successfully", {
              duration: 4000,
              position: "top-right",
              style: {
                background: "#dcfce7",
                color: "#166534",
              },
            });
          }
        } catch (error) {
          console.error("Error parsing WebSocket response:", error);
        } finally {
          setIsPrinting(false);
        }
      };
    };

    connectWebSocket();

    return () => {
      if (socketRef.current) {
        socketRef.current.close();
      }
    };
  }, [webSocketUrl]);

  // const handlePrintBill = () => {
  //   console.log("🖨️ Print button clicked");

  //   const isFromApp = navigator.userAgent.includes("CloudRestroAPK");
  //   const isSettingMatched = true;

  //   // Build bill data
  //   const itemsList =
  //     responseData?.orderDetails || responseData?.items || [];

  //   const formattedItems = itemsList.map((item) => {
  //     const quantity = item.finalQuantity ?? item.quantity ?? 0;
  //     const unitPrice = Number(item.price ?? item.productPrice ?? 0);
  //     const totalPrice = unitPrice * quantity;

  //     return {
  //       itemName: item.name || item.productName,
  //       quantity,
  //       unitPrice,
  //       totalPrice,
  //       isComplimentary: item.isComplimentary || false,
  //     };
  //   });
  //   console.log("🚀 ~ handlePrintBill ~ itemsList:", itemsList)
  //   console.log("🚀 ~ handlePrintBill ~ formattedItems:", formattedItems)

  //   const totals =
  //     typeof calculateTotals === "function"
  //       ? calculateTotals()
  //       : {
  //           subTotal: responseData?.totalAmount ?? 0,
  //           total: responseData?.grandTotal ?? 0,
  //         };

  //   const userData = JSON.parse(localStorage.getItem("user") || "{}");
  //   const token = userData.accessToken || userData.token || null;

  // const billData = {
  //   cafeName: userInfo?.organizationInfo?.name,
  //   location: userInfo?.organizationInfo?.address1,
  //   pan: userInfo?.organizationInfo?.panNumber,
  //   phone: userInfo?.organizationInfo?.tel,
  //   billprintedby: userInfo?.userName,
  //   type: "PRINT_BILL",
  //   items: formattedItems,
  //   subTotal: Number(totals?.subTotal) || 0,
  //   netAmount: Number(totals?.total) || 0,
  //   salesInvoiceNumber:
  //     responseData?.invoiceNumber || responseData?.orderRefrenceId,
  //   message: `Thank you for visiting ${userInfo?.organizationInfo?.name}!`,
  //   isestimateprint: isestimateprint,
  // };

  //   if (selectedCustomer?.firstName || selectedCustomer?.lastName) {
  //     billData.customername = `${selectedCustomer?.firstName || ""} ${
  //       selectedCustomer?.lastName || ""
  //     }`.trim();
  //   }
  //   if (selectedCustomer?.phoneNo) {
  //     billData.customerphone = selectedCustomer.phoneNo;
  //   }
  //   if (selectedCustomer?.address) {
  //     billData.customeraddress = selectedCustomer.address;
  //   }

  //   if (totalDiscount) {
  //     billData.discount = Math.round(totalDiscount);
  //   } else if (responseData?.discountAmount) {
  //     billData.discount = Number(responseData.discountAmount);
  //   }

  //   console.log("🧾 Final Bill Data:", billData);

  //   // 🔹 If from app, send via deep link
  //   if (isFromApp && isSettingMatched) {
  //     console.log("📱 Running inside APK WebView — sending to app");
  //     const payloadData = {
  //       token, // Add the auth token here
  //       bill: billData,
  //     };

  //     const payload = encodeURIComponent(JSON.stringify(payloadData));
  //     console.log("This is payload", payload);
  //     setTimeout(() => {
  //       window.location.href = `app://printInvoice?data=${payload}`;
  //     }, 100); // small delay so console.log appears
  //     return;
  //   }

  //   // 🔹 Otherwise continue WebSocket printing
  //   if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
  //     setIsPrinting(true);
  //     socketRef.current.send(JSON.stringify(billData));
  //   } else {
  //     console.error("❌ WebSocket not connected");
  //     setConnectionStatus("error");
  //     toast.error("WebSocket not connected. Please try again.", {
  //       duration: 4000,
  //       position: "top-right",
  //       style: {
  //         background: "#fee2e2",
  //         color: "#b91c1c",
  //       },
  //     });
  //   }
  // };

  const handlePrintBill = () => {
    console.log("🖨️ Print button clicked");
    const mappedPayments = (selectedPayments || []).map((p) => ({
      type: p?.name || "",
      transactionType: p?.transactionType || 1, // default to 1 (Pay-in)
      amount: Number(responseData?.grandTotal || 0), // full amount paid
      date: new Date().toISOString(), // print timestamp
    }));

    console.log("🚀 ~ handlePrintBill ~ mappedPayments:", mappedPayments);

    const isFromApp = navigator.userAgent.includes("CloudRestroAPK");
    const isSettingMatched = true;

    // Format items
    const itemsList = responseData?.orderDetails || responseData?.items || [];
    console.log("🚀 ~ handlePrintBill ~ responseData:", responseData);
    const formattedItems = itemsList.map((item) => {
      console.log("🚀 ~ handlePrintBill ~ item:", item);
      const quantity = item.quantity || 0;
      const unitPrice = Number(item.price ?? item.productPrice ?? 0);
      const totalPrice = unitPrice * quantity;

      return {
        itemName: item.name || item.productName,
        quantity,
        unitPrice,
        totalPrice,
        complimentaryQuantity: item.complimentaryQuantity,
        // isComplimentary: item.isComplimentary || false,
        isComplimentary: item.isComplimentary || item.complimentaryQuantity > 0,
      };
    });

    // Adding the complimentary data into formatted items

    // const formattedItems = [];

    // itemsList.forEach((item) => {
    //   const normalQty = item.quantity || 0;
    //   const compQty = item.complimentaryQuantity || 0;
    //   const price = Number(
    //     item.price ?? item.productPrice ?? item.unitPrice ?? 0
    //   );

    //   // 🔹 Normal item entry (if quantity > 0)
    //   if (normalQty > 0) {
    //     formattedItems.push({
    //       itemName: item.name || item.productName || item.itemName,
    //       quantity: normalQty,
    //       unitPrice: price,
    //       totalPrice: price * normalQty,
    //       complimentaryQuantity: 0,
    //       isComplimentary: false,
    //     });
    //   }

    //   // 🔹 Complimentary item entry (if complimentaryQuantity > 0)
    //   if (compQty > 0) {
    //     formattedItems.push({
    //       itemName:
    //         (item.name || item.productName || item.itemName) +
    //         " (Complimentary)",
    //       quantity: compQty,
    //       unitPrice: 0,
    //       totalPrice: 0,
    //       complimentaryQuantity: compQty,
    //       isComplimentary: true,
    //     });
    //   }
    // });

    console.log("🚀 ~ handlePrintBill ~ formattedItems:", formattedItems);

    const totals =
      typeof calculateTotals === "function"
        ? calculateTotals()
        : {
            subTotal: responseData?.totalAmount ?? 0,
            total: responseData?.grandTotal ?? 0,
          };

    const userData = JSON.parse(localStorage.getItem("user") || "{}");
    const token = userData.accessToken || userData.token || null;

    // 🧾 Create proper bill structure
    const bill = {
      cafeName: userInfo?.organizationInfo?.name,
      location: userInfo?.organizationInfo?.address1,
      phone: userInfo?.organizationInfo?.tel,
      pan: userInfo?.organizationInfo?.panNumber,
      billprintedby: userInfo?.userName,
      tableName: responseData?.tableName || "",
      salesInvoiceNumber:
        responseData?.invoiceNumber || responseData?.orderRefrenceId,
      refSalesInvoiceNumber: responseData?.refSalesInvoiceNumber || "",
      returnInvoiceNumber: responseData?.returnInvoiceNumber || "",
      isestimateprint: !!isestimateprint,
      message: `Thank you for visiting ${userInfo?.organizationInfo?.name}!`,
      billRemarks: responseData?.remarks || "",
      customerName: `${selectedCustomer?.firstName || ""} ${
        selectedCustomer?.lastName || ""
      }`.trim(),
      customerPhone: selectedCustomer?.phoneNo || "",
      customerAddress: selectedCustomer?.address || "",
      customerPan: selectedCustomer?.pan || "",
      subTotal: Number(totals?.subTotal) || 0,
      discount: Math.round(totalDiscount || responseData?.discountAmount || 0),
      vat: Number(responseData?.taxAmount || 0),
      serviceCharge: Number(responseData?.serviceCharge || 0),
      netAmount: Number(totals?.total) || 0,
      // paymentTypes: responseData?.paymentTypes,
      paymentTypes: mappedPayments.map((p) => p.type),

      items: formattedItems,
    };
    console.log("🚀 ~ handlePrintBill ~ bill:", bill);
    console.log("🚀 ~ handlePrintBill ~ bill:", bill);

    const billData = {
      cafeName: userInfo?.organizationInfo?.name,
      location: userInfo?.organizationInfo?.address1,
      pan: userInfo?.organizationInfo?.panNumber,
      phone: userInfo?.organizationInfo?.tel,
      billprintedby: userInfo?.userName,
      type: "PRINT_BILL",

      discount: Math.round(totalDiscount || responseData?.discountAmount || 0),
      items: formattedItems,
      subTotal: Number(totals?.subTotal) || 0,
      netAmount: Number(totals?.total) || 0,
      salesInvoiceNumber:
        responseData?.invoiceNumber || responseData?.orderRefrenceId,
      message: `Thank you for visiting ${userInfo?.organizationInfo?.name}!`,
      isestimateprint: isestimateprint,

      paymentTypes: mappedPayments,
    };
    console.log("🚀 ~ handlePrintBill ~ billData:", billData);

    // ✅ Wrap token + bill
    const finalPayload = {
      token: token,
      bill: bill,
    };

    console.log("🧾 Final Payload to send:", finalPayload);

    // 📱 If running inside app → deep link
    if (isFromApp && isSettingMatched) {
      const payload = encodeURIComponent(JSON.stringify(finalPayload));
      setTimeout(() => {
        window.location.href = `app://printInvoice?data=${payload}`;
      }, 100);
      return;
    }

    // 🖨️ Otherwise send via WebSocket
    if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
      setIsPrinting(true);
      socketRef.current.send(JSON.stringify(billData));
    } else {
      console.error("❌ WebSocket not connected");
      setConnectionStatus("error");
      toast.error("WebSocket not connected. Please try again.", {
        duration: 4000,
        position: "top-right",
        style: { background: "#fee2e2", color: "#b91c1c" },
      });
    }
  };

  return (
    <div>
      <Toaster />
      <button
        className="btn btn-soft-success"
        title="Print"
        onClick={handlePrintBill}
        disabled={!webSocketUrl || isPrinting}
      >
        {isPrinting ? (
          "Printing..."
        ) : connectionStatus === "connecting" ? (
          "Connecting..."
        ) : (
          <i className="bx bx-printer"></i>
        )}
      </button>
    </div>
  );
};
